<div class="text-muted" *ngIf="!loading">
  {{ singleQuestionsCount }}
  {{ 'exams.question_groups.single_question_count' | translate }} |
  {{ questionSeriesCount }}
  {{ 'exams.question_groups.question_group_count' | translate }} |
  {{ pointsCount }} {{ 'exams.question_groups.total_points' | translate }} |
  {{ assetMbSize | number : '1.0-0' }}MB
  {{ 'exams.question_groups.asset_size' | translate }}
</div>
